// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';


import { Modal } from 'react-bootstrap';
import NumberInput from './NumberInput';

export default class NumberInputModal extends Component {

  static defaultProps = {
    value: null,

    min: 0,

    max: null,

    value: null
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    title: PropTypes.string.isRequired,

    onChange: PropTypes.func.isRequired,

    value: PropTypes.number,

    min: PropTypes.number,

    max: PropTypes.number
  };

  state = {
    value: this.props.value
  };

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  onChange = (value) => {
    this.setState({
      value: parseInt(value, 10)
    });
  };

  onSubmit = () => {
    this.props.onChange(this.state.value);
    this.props.onHide();
  };

  // -- renderers

  renderBody() {
    return (
      <div className="text-center">

        <NumberInput
          className="form-control"
          value={this.state.value}
          onChange={this.onChange}
          min={this.props.min}
          max={this.props.max}
          format={NumberInput.INT_FORMAT}
          autoFocus
        />

        <br /><br />

        <button
          className="btn btn-primary submit text-center"
          type="submit"
          disabled={this.state.value > this.props.max}
          onClick={this.onSubmit}
        >
          {I18n.tr('components.numner_input_modal.submit')}
        </button>
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="small"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}
